export const ROUTES_DASHBOARD_ROOT = '/dashboard'
